module.exports = __webpack_public_path__ + "static/media/shadow.0f0119c8.jpg";